import { Link } from 'react-router-dom';

function Card(props) {
  return (  
    <Link to={props.url} className="col-lg-4 col-md-6 col-sm-12 text-center text-card" style={{ textDecoration: 'none' }} >
        <div className="rounded-circle" style={{ backgroundImage: "url('/images/" + props.image + "')", backgroundSize: 'cover', width: '140px', height: '140px', margin: '20px auto' }} alt="140x140" data-holder-rendered="true"></div>
        <h3>{props.title}</h3>
        <p style={{ color: '#666' }} dangerouslySetInnerHTML={{ __html: props.body}}></p>
    </Link>
  );
}

export default Card;
